import { render, staticRenderFns } from "./BlockPicker.vue?vue&type=template&id=3aa5cacf&scoped=true"
import script from "./BlockPicker.vue?vue&type=script&lang=js"
export * from "./BlockPicker.vue?vue&type=script&lang=js"
import style0 from "./BlockPicker.vue?vue&type=style&index=0&id=3aa5cacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5cacf",
  null
  
)

export default component.exports